import React from "react";
import { FormControl, InputBase, InputLabel } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledInput = styled(InputBase)(({ theme }) => ({
  "& .MuiInputBase-root": {
    marginTop: theme.spacing(3),
  },
  "& .MuiInputBase-input": {
    flex: 1,
    backgroundColor: "#f6f6f6",
    borderRadius: "8px",
    boxShadow: "inset 0px 1px 1px 1px #e5e5e5",
    padding: "10px 12px",
    marginTop: "25px",
  },
}));

const StyledLabel = styled(InputLabel)(({ theme }) => ({
  color: theme.palette.text.primary,
  transform: "translate(0, -5px)",
}));

const FormField = ({ label, type, name, handleChange, readOnly, isKiosk }) => {
  return (
    <FormControl variant="standard" sx={{ display: "flex", marginBottom: "20px" }}>
      <StyledLabel shrink>{label}</StyledLabel>
      <StyledInput
        autoComplete={isKiosk ? "one-time-code" : ""}
        readOnly={readOnly}
        id={name}
        name={name}
        type={type}
        onChange={handleChange}
      />
    </FormControl>
  );
};

export default FormField;
